/* eslint-disable no-console */

export const demoAnalyticsData = {
  dailyActivities: [
    {
      date: '2019-04-01T00:00:00',
      dateView: 'Apr 01',
      invitesSent: 243,
      clicks: 264,
      clickRate: 57,
      bookings: 69,
      revenue: 0,
      conversion: 60,
      campaigns: [
        {
          uiId: '1904051',
          campaign: 'AfterLastVisit',
          invitesSent: 1,
          clicks: 1,
          clickRate: 100
        },
        {
          uiId: '1904052',
          campaign: 'Birthday',
          invitesSent: 1,
          clicks: 1,
          clickRate: 85
        },
        {
          uiId: '1904053',
          campaign: 'Lost6Months',
          invitesSent: 1,
          clicks: 1,
          clickRate: 90
        }
      ],
      clickRateGraph: 53
    },
    {
      date: '2019-04-02T00:00:00',
      dateView: 'Apr 02',
      invitesSent: 248,
      clicks: 227,
      clickRate: 85,
      bookings: 50,
      revenue: 0,
      conversion: 53,
      campaigns: [
        {
          uiId: '1904051',
          campaign: 'AfterLastVisit',
          invitesSent: 1,
          clicks: 1,
          clickRate: 100
        },
        {
          uiId: '1904052',
          campaign: 'Birthday',
          invitesSent: 1,
          clicks: 1,
          clickRate: 85
        },
        {
          uiId: '1904053',
          campaign: 'Lost6Months',
          invitesSent: 1,
          clicks: 1,
          clickRate: 90
        }
      ],
      clickRateGraph: 32
    },
    {
      date: '2019-04-03T00:00:00',
      dateView: 'Apr 03',
      invitesSent: 257,
      clicks: 209,
      clickRate: 94,
      bookings: 47,
      revenue: 0,
      conversion: 47,
      campaigns: [
        {
          uiId: '1904051',
          campaign: 'AfterLastVisit',
          invitesSent: 1,
          clicks: 1,
          clickRate: 100
        },
        {
          uiId: '1904052',
          campaign: 'Birthday',
          invitesSent: 1,
          clicks: 1,
          clickRate: 85
        },
        {
          uiId: '1904053',
          campaign: 'Lost6Months',
          invitesSent: 1,
          clicks: 1,
          clickRate: 90
        }
      ],
      clickRateGraph: 39
    },
    {
      date: '2019-04-04T00:00:00',
      dateView: 'Apr 04',
      invitesSent: 272,
      clicks: 281,
      clickRate: 52,
      bookings: 69,
      revenue: 0,
      conversion: 55,
      campaigns: [
        {
          uiId: '1904051',
          campaign: 'AfterLastVisit',
          invitesSent: 1,
          clicks: 1,
          clickRate: 100
        },
        {
          uiId: '1904052',
          campaign: 'Birthday',
          invitesSent: 1,
          clicks: 1,
          clickRate: 85
        },
        {
          uiId: '1904053',
          campaign: 'Lost6Months',
          invitesSent: 1,
          clicks: 1,
          clickRate: 90
        }
      ],
      clickRateGraph: 76
    },
    {
      date: '2019-04-05T00:00:00',
      dateView: 'Apr 05',
      invitesSent: 1,
      clicks: 1,
      clickRate: 100,
      bookings: 51,
      revenue: 0,
      conversion: 57,
      campaigns: [
        {
          uiId: '1904051',
          campaign: 'AfterLastVisit',
          invitesSent: 1,
          clicks: 1,
          clickRate: 100
        },
        {
          uiId: '1904052',
          campaign: 'Birthday',
          invitesSent: 1,
          clicks: 1,
          clickRate: 85
        },
        {
          uiId: '1904053',
          campaign: 'Lost6Months',
          invitesSent: 1,
          clicks: 1,
          clickRate: 90
        }
      ],
      clickRateGraph: 100
    },
    {
      date: '2019-04-06T00:00:00',
      dateView: 'Apr 06',
      invitesSent: 218,
      clicks: 3,
      clickRate: 300,
      bookings: 38,
      revenue: 0,
      conversion: 56,
      campaigns: [
        {
          uiId: '1904051',
          campaign: 'AfterLastVisit',
          invitesSent: 1,
          clicks: 1,
          clickRate: 100
        },
        {
          uiId: '1904052',
          campaign: 'Birthday',
          invitesSent: 1,
          clicks: 1,
          clickRate: 85
        },
        {
          uiId: '1904053',
          campaign: 'Lost6Months',
          invitesSent: 1,
          clicks: 1,
          clickRate: 90
        }
      ],
      clickRateGraph: 100
    },
    {
      date: '2019-04-07T00:00:00',
      dateView: 'Apr 07',
      invitesSent: 202,
      clicks: 237,
      clickRate: 95,
      bookings: 51,
      revenue: 0,
      conversion: 51,
      campaigns: [
        {
          uiId: '1904051',
          campaign: 'AfterLastVisit',
          invitesSent: 1,
          clicks: 1,
          clickRate: 100
        },
        {
          uiId: '1904052',
          campaign: 'Birthday',
          invitesSent: 1,
          clicks: 1,
          clickRate: 85
        },
        {
          uiId: '1904053',
          campaign: 'Lost6Months',
          invitesSent: 1,
          clicks: 1,
          clickRate: 90
        }
      ],
      clickRateGraph: 45
    },
    {
      date: '2019-04-08T00:00:00',
      dateView: 'Apr 08',
      invitesSent: 253,
      clicks: 221,
      clickRate: 46,
      bookings: 38,
      revenue: 0,
      conversion: 48,
      campaigns: [
        {
          uiId: '1904051',
          campaign: 'AfterLastVisit',
          invitesSent: 1,
          clicks: 1,
          clickRate: 100
        },
        {
          uiId: '1904052',
          campaign: 'Birthday',
          invitesSent: 1,
          clicks: 1,
          clickRate: 85
        },
        {
          uiId: '1904053',
          campaign: 'Lost6Months',
          invitesSent: 1,
          clicks: 1,
          clickRate: 90
        }
      ],
      clickRateGraph: 100
    },
    {
      date: '2019-04-09T00:00:00',
      dateView: 'Apr 09',
      invitesSent: 276,
      clicks: 279,
      clickRate: 32,
      bookings: 48,
      revenue: 0,
      conversion: 57,
      campaigns: [
        {
          uiId: '1904051',
          campaign: 'AfterLastVisit',
          invitesSent: 1,
          clicks: 1,
          clickRate: 100
        },
        {
          uiId: '1904052',
          campaign: 'Birthday',
          invitesSent: 1,
          clicks: 1,
          clickRate: 85
        },
        {
          uiId: '1904053',
          campaign: 'Lost6Months',
          invitesSent: 1,
          clicks: 1,
          clickRate: 90
        }
      ],
      clickRateGraph: 45
    },
    {
      date: '2019-04-10T00:00:00',
      dateView: 'Apr 10',
      invitesSent: 290,
      clicks: 210,
      clickRate: 73,
      bookings: 37,
      revenue: 0,
      conversion: 36,
      campaigns: [
        {
          uiId: '1904051',
          campaign: 'AfterLastVisit',
          invitesSent: 1,
          clicks: 1,
          clickRate: 100
        },
        {
          uiId: '1904052',
          campaign: 'Birthday',
          invitesSent: 1,
          clicks: 1,
          clickRate: 85
        },
        {
          uiId: '1904053',
          campaign: 'Lost6Months',
          invitesSent: 1,
          clicks: 1,
          clickRate: 90
        }
      ],
      clickRateGraph: 88
    },
    {
      date: '2019-04-11T00:00:00',
      dateView: 'Apr 11',
      invitesSent: 280,
      clicks: 217,
      clickRate: 99,
      bookings: 45,
      revenue: 0,
      conversion: 42,
      campaigns: [
        {
          uiId: '1904051',
          campaign: 'AfterLastVisit',
          invitesSent: 1,
          clicks: 1,
          clickRate: 100
        },
        {
          uiId: '1904052',
          campaign: 'Birthday',
          invitesSent: 1,
          clicks: 1,
          clickRate: 85
        },
        {
          uiId: '1904053',
          campaign: 'Lost6Months',
          invitesSent: 1,
          clicks: 1,
          clickRate: 90
        }
      ],
      clickRateGraph: 58
    },
    {
      date: '2019-04-12T00:00:00',
      dateView: 'Apr 12',
      invitesSent: 264,
      clicks: 260,
      clickRate: 33,
      bookings: 45,
      revenue: 0,
      conversion: 52,
      campaigns: [
        {
          uiId: '1904051',
          campaign: 'AfterLastVisit',
          invitesSent: 1,
          clicks: 1,
          clickRate: 100
        },
        {
          uiId: '1904052',
          campaign: 'Birthday',
          invitesSent: 1,
          clicks: 1,
          clickRate: 85
        },
        {
          uiId: '1904053',
          campaign: 'Lost6Months',
          invitesSent: 1,
          clicks: 1,
          clickRate: 90
        }
      ],
      clickRateGraph: 80
    },
    {
      date: '2019-04-13T00:00:00',
      dateView: 'Apr 13',
      invitesSent: 202,
      clicks: 277,
      clickRate: 66,
      bookings: 46,
      revenue: 0,
      conversion: 37,
      campaigns: [
        {
          uiId: '1904051',
          campaign: 'AfterLastVisit',
          invitesSent: 1,
          clicks: 1,
          clickRate: 100
        },
        {
          uiId: '1904052',
          campaign: 'Birthday',
          invitesSent: 1,
          clicks: 1,
          clickRate: 85
        },
        {
          uiId: '1904053',
          campaign: 'Lost6Months',
          invitesSent: 1,
          clicks: 1,
          clickRate: 90
        }
      ],
      clickRateGraph: 86
    },
    {
      date: '2019-04-14T00:00:00',
      dateView: 'Apr 14',
      invitesSent: 211,
      clicks: 296,
      clickRate: 92,
      bookings: 43,
      revenue: 0,
      conversion: 36,
      campaigns: [
        {
          uiId: '1904051',
          campaign: 'AfterLastVisit',
          invitesSent: 1,
          clicks: 1,
          clickRate: 100
        },
        {
          uiId: '1904052',
          campaign: 'Birthday',
          invitesSent: 1,
          clicks: 1,
          clickRate: 85
        },
        {
          uiId: '1904053',
          campaign: 'Lost6Months',
          invitesSent: 1,
          clicks: 1,
          clickRate: 90
        }
      ],
      clickRateGraph: 53
    },
    {
      date: '2019-04-15T00:00:00',
      dateView: 'Apr 15',
      invitesSent: 281,
      clicks: 294,
      clickRate: 84,
      bookings: 56,
      revenue: 0,
      conversion: 37,
      campaigns: [
        {
          uiId: '1904051',
          campaign: 'AfterLastVisit',
          invitesSent: 1,
          clicks: 1,
          clickRate: 100
        },
        {
          uiId: '1904052',
          campaign: 'Birthday',
          invitesSent: 1,
          clicks: 1,
          clickRate: 85
        },
        {
          uiId: '1904053',
          campaign: 'Lost6Months',
          invitesSent: 1,
          clicks: 1,
          clickRate: 90
        }
      ],
      clickRateGraph: 68
    },
    {
      date: '2019-04-16T00:00:00',
      dateView: 'Apr 16',
      invitesSent: 268,
      clicks: 267,
      clickRate: 45,
      bookings: 36,
      revenue: 0,
      conversion: 40,
      campaigns: [
        {
          uiId: '1904051',
          campaign: 'AfterLastVisit',
          invitesSent: 1,
          clicks: 1,
          clickRate: 100
        },
        {
          uiId: '1904052',
          campaign: 'Birthday',
          invitesSent: 1,
          clicks: 1,
          clickRate: 85
        },
        {
          uiId: '1904053',
          campaign: 'Lost6Months',
          invitesSent: 1,
          clicks: 1,
          clickRate: 90
        }
      ],
      clickRateGraph: 33
    },
    {
      date: '2019-04-17T00:00:00',
      dateView: 'Apr 17',
      invitesSent: 270,
      clicks: 235,
      clickRate: 43,
      bookings: 64,
      revenue: 0,
      conversion: 31,
      campaigns: [
        {
          uiId: '1904051',
          campaign: 'AfterLastVisit',
          invitesSent: 1,
          clicks: 1,
          clickRate: 100
        },
        {
          uiId: '1904052',
          campaign: 'Birthday',
          invitesSent: 1,
          clicks: 1,
          clickRate: 85
        },
        {
          uiId: '1904053',
          campaign: 'Lost6Months',
          invitesSent: 1,
          clicks: 1,
          clickRate: 90
        }
      ],
      clickRateGraph: 64
    },
    {
      date: '2019-04-18T00:00:00',
      dateView: 'Apr 18',
      invitesSent: 267,
      clicks: 247,
      clickRate: 53,
      bookings: 63,
      revenue: 0,
      conversion: 39,
      campaigns: [
        {
          uiId: '1904051',
          campaign: 'AfterLastVisit',
          invitesSent: 1,
          clicks: 1,
          clickRate: 100
        },
        {
          uiId: '1904052',
          campaign: 'Birthday',
          invitesSent: 1,
          clicks: 1,
          clickRate: 85
        },
        {
          uiId: '1904053',
          campaign: 'Lost6Months',
          invitesSent: 1,
          clicks: 1,
          clickRate: 90
        }
      ],
      clickRateGraph: 71
    },
    {
      date: '2019-04-19T00:00:00',
      dateView: 'Apr 19',
      invitesSent: 286,
      clicks: 1,
      clickRate: 100,
      bookings: 57,
      revenue: 0,
      conversion: 31,
      campaigns: [
        {
          uiId: '1904051',
          campaign: 'AfterLastVisit',
          invitesSent: 1,
          clicks: 1,
          clickRate: 100
        },
        {
          uiId: '1904052',
          campaign: 'Birthday',
          invitesSent: 1,
          clicks: 1,
          clickRate: 85
        },
        {
          uiId: '1904053',
          campaign: 'Lost6Months',
          invitesSent: 1,
          clicks: 1,
          clickRate: 90
        }
      ],
      clickRateGraph: 100
    },
    {
      date: '2019-04-20T00:00:00',
      dateView: 'Apr 20',
      invitesSent: 279,
      clicks: 210,
      clickRate: 71,
      bookings: 50,
      revenue: 0,
      conversion: 33,
      campaigns: [
        {
          uiId: '1904051',
          campaign: 'AfterLastVisit',
          invitesSent: 1,
          clicks: 1,
          clickRate: 100
        },
        {
          uiId: '1904052',
          campaign: 'Birthday',
          invitesSent: 1,
          clicks: 1,
          clickRate: 85
        },
        {
          uiId: '1904053',
          campaign: 'Lost6Months',
          invitesSent: 1,
          clicks: 1,
          clickRate: 90
        }
      ],
      clickRateGraph: 74
    },
    {
      date: '2019-04-21T00:00:00',
      dateView: 'Apr 21',
      invitesSent: 212,
      clicks: 293,
      clickRate: 63,
      bookings: 36,
      revenue: 0,
      conversion: 31,
      campaigns: [
        {
          uiId: '1904051',
          campaign: 'AfterLastVisit',
          invitesSent: 1,
          clicks: 1,
          clickRate: 100
        },
        {
          uiId: '1904052',
          campaign: 'Birthday',
          invitesSent: 1,
          clicks: 1,
          clickRate: 85
        },
        {
          uiId: '1904053',
          campaign: 'Lost6Months',
          invitesSent: 1,
          clicks: 1,
          clickRate: 90
        }
      ],
      clickRateGraph: 50
    },
    {
      date: '2019-04-22T00:00:00',
      dateView: 'Apr 22',
      invitesSent: 233,
      clicks: 246,
      clickRate: 86,
      bookings: 37,
      revenue: 0,
      conversion: 48,
      campaigns: [
        {
          uiId: '1904051',
          campaign: 'AfterLastVisit',
          invitesSent: 1,
          clicks: 1,
          clickRate: 100
        },
        {
          uiId: '1904052',
          campaign: 'Birthday',
          invitesSent: 1,
          clicks: 1,
          clickRate: 85
        },
        {
          uiId: '1904053',
          campaign: 'Lost6Months',
          invitesSent: 1,
          clicks: 1,
          clickRate: 90
        }
      ],
      clickRateGraph: 62
    },
    {
      date: '2019-04-23T00:00:00',
      dateView: 'Apr 23',
      invitesSent: 295,
      clicks: 231,
      clickRate: 34,
      bookings: 31,
      revenue: 0,
      conversion: 48,
      campaigns: [
        {
          uiId: '1904051',
          campaign: 'AfterLastVisit',
          invitesSent: 1,
          clicks: 1,
          clickRate: 100
        },
        {
          uiId: '1904052',
          campaign: 'Birthday',
          invitesSent: 1,
          clicks: 1,
          clickRate: 85
        },
        {
          uiId: '1904053',
          campaign: 'Lost6Months',
          invitesSent: 1,
          clicks: 1,
          clickRate: 90
        }
      ],
      clickRateGraph: 50
    },
    {
      date: '2019-04-24T00:00:00',
      dateView: 'Apr 24',
      invitesSent: 207,
      clicks: 299,
      clickRate: 40,
      bookings: 69,
      revenue: 0,
      conversion: 35,
      campaigns: [
        {
          uiId: '1904051',
          campaign: 'AfterLastVisit',
          invitesSent: 1,
          clicks: 1,
          clickRate: 100
        },
        {
          uiId: '1904052',
          campaign: 'Birthday',
          invitesSent: 1,
          clicks: 1,
          clickRate: 85
        },
        {
          uiId: '1904053',
          campaign: 'Lost6Months',
          invitesSent: 1,
          clicks: 1,
          clickRate: 90
        }
      ],
      clickRateGraph: 98
    },
    {
      date: '2019-04-25T00:00:00',
      dateView: 'Apr 25',
      invitesSent: 3,
      clicks: 223,
      clickRate: 80,
      bookings: 61,
      revenue: 0,
      conversion: 34,
      campaigns: [
        {
          uiId: '1904051',
          campaign: 'AfterLastVisit',
          invitesSent: 1,
          clicks: 1,
          clickRate: 100
        },
        {
          uiId: '1904052',
          campaign: 'Birthday',
          invitesSent: 1,
          clicks: 1,
          clickRate: 85
        },
        {
          uiId: '1904053',
          campaign: 'Lost6Months',
          invitesSent: 1,
          clicks: 1,
          clickRate: 90
        }
      ],
      clickRateGraph: 63
    },
    {
      date: '2019-04-26T00:00:00',
      dateView: 'Apr 26',
      invitesSent: 4,
      clicks: 206,
      clickRate: 75,
      bookings: 40,
      revenue: 0,
      conversion: 60,
      campaigns: [
        {
          uiId: '1904051',
          campaign: 'AfterLastVisit',
          invitesSent: 1,
          clicks: 1,
          clickRate: 100
        },
        {
          uiId: '1904052',
          campaign: 'Birthday',
          invitesSent: 1,
          clicks: 1,
          clickRate: 85
        },
        {
          uiId: '1904053',
          campaign: 'Lost6Months',
          invitesSent: 1,
          clicks: 1,
          clickRate: 90
        }
      ],
      clickRateGraph: 57
    },
    {
      date: '2019-04-27T00:00:00',
      dateView: 'Apr 27',
      invitesSent: 247,
      clicks: 230,
      clickRate: 98,
      bookings: 39,
      revenue: 0,
      conversion: 43,
      campaigns: [
        {
          uiId: '1904051',
          campaign: 'AfterLastVisit',
          invitesSent: 1,
          clicks: 1,
          clickRate: 100
        },
        {
          uiId: '1904052',
          campaign: 'Birthday',
          invitesSent: 1,
          clicks: 1,
          clickRate: 85
        },
        {
          uiId: '1904053',
          campaign: 'Lost6Months',
          invitesSent: 1,
          clicks: 1,
          clickRate: 90
        }
      ],
      clickRateGraph: 48
    },
    {
      date: '2019-04-28T00:00:00',
      dateView: 'Apr 28',
      invitesSent: 242,
      clicks: 277,
      clickRate: 55,
      bookings: 57,
      revenue: 0,
      conversion: 54,
      campaigns: [
        {
          uiId: '1904051',
          campaign: 'AfterLastVisit',
          invitesSent: 1,
          clicks: 1,
          clickRate: 100
        },
        {
          uiId: '1904052',
          campaign: 'Birthday',
          invitesSent: 1,
          clicks: 1,
          clickRate: 85
        },
        {
          uiId: '1904053',
          campaign: 'Lost6Months',
          invitesSent: 1,
          clicks: 1,
          clickRate: 90
        }
      ],
      clickRateGraph: 77
    },
    {
      date: '2019-04-29T00:00:00',
      dateView: 'Apr 29',
      invitesSent: 272,
      clicks: 269,
      clickRate: 96,
      bookings: 68,
      revenue: 0,
      conversion: 60,
      campaigns: [
        {
          uiId: '1904051',
          campaign: 'AfterLastVisit',
          invitesSent: 1,
          clicks: 1,
          clickRate: 100
        },
        {
          uiId: '1904052',
          campaign: 'Birthday',
          invitesSent: 1,
          clicks: 1,
          clickRate: 85
        },
        {
          uiId: '1904053',
          campaign: 'Lost6Months',
          invitesSent: 1,
          clicks: 1,
          clickRate: 90
        }
      ],
      clickRateGraph: 80
    },
    {
      date: '2019-04-30T00:00:00',
      dateView: 'Apr 30',
      invitesSent: 11,
      clicks: 269,
      clickRate: 45,
      bookings: 30,
      revenue: 0,
      conversion: 43,
      campaigns: [
        {
          uiId: '1904051',
          campaign: 'AfterLastVisit',
          invitesSent: 1,
          clicks: 1,
          clickRate: 100
        },
        {
          uiId: '1904052',
          campaign: 'Birthday',
          invitesSent: 1,
          clicks: 1,
          clickRate: 85
        },
        {
          uiId: '1904053',
          campaign: 'Lost6Months',
          invitesSent: 1,
          clicks: 1,
          clickRate: 90
        }
      ],
      clickRateGraph: 90
    }
  ],
  totalInvitesSent: 1020,
  totalClicks: 750,
  clickRate: 90.32,
  totalBookings: 5723,
  averageConversion: 56.48,
  totalConvertedRevenue: 324551,
  campaignsSummary: [
    {
      uiId: '0101011',
      campaign: 'AfterLastVisit',
      invitesSent: 13,
      clicks: 5,
      clickRate: 90.96
    },
    {
      uiId: '0101016',
      campaign: 'CardAbandonmentOptedIn',
      invitesSent: 5,
      clicks: 259,
      clickRate: 78.46
    },
    {
      uiId: '0101015',
      campaign: 'CheckedOutReview',
      invitesSent: 1,
      clicks: 292,
      clickRate: 85.24
    }
  ]
}

export const demoActiveGuestData = [
  {
    subscriberId: '6z1rPORnotr',
    fullName: 'Ye Wenjie',
    locationCountry: 'CA',
    locationStateCountry: 'US',
    phoneNumber: '(555) 555-55-55',
    phoneType: 'Mobile',
    phoneCarrier: 'T-Mobile USA, Inc.',
    addedOn: '2019-05-08T14:48:57.688Z',
    lastUsageOn: '2019-05-08T14:48:57.688Z',
    lastActivityOn: '2019-05-08T14:48:57.688Z',
    lastActivityCampaign: 'Cancelled',
    businessValue: 0,
    numberOfClicks: 19,
    numberOfShares: 10,
    numberOfBookings: 7,
    nextInviteCategory: null,
    nextInviteDate: null,
    searchKey: ''
  },
  {
    subscriberId: '6pS8_4gjy43',
    fullName: 'Jonathan Riker',
    locationCountry: 'US',
    locationStateCountry: 'TR',
    phoneNumber: '(555) 555-55-55',
    phoneType: 'Mobile',
    phoneCarrier: 'T-Mobile USA, Inc.',
    addedOn: '2019-05-08T14:48:57.688Z',
    lastUsageOn: '2019-05-08T14:48:57.688Z',
    lastActivityOn: '2019-05-08T14:48:57.688Z',
    lastActivityCampaign: 'Cancelled',
    businessValue: 0,
    numberOfClicks: 5,
    numberOfShares: 13,
    numberOfBookings: 1,
    nextInviteCategory: null,
    nextInviteDate: null,
    searchKey: ''
  },
  {
    subscriberId: 'Xl_CChTignN',
    fullName: 'John Doe',
    locationCountry: 'US',
    locationStateCountry: 'TR',
    phoneNumber: '(555) 555-55-55',
    phoneType: 'Mobile',
    phoneCarrier: 'T-Mobile USA, Inc.',
    addedOn: '2019-05-08T14:48:57.688Z',
    lastUsageOn: '2019-05-08T14:48:57.688Z',
    lastActivityOn: '2019-05-08T14:48:57.688Z',
    lastActivityCampaign: 'Lost6Months',
    businessValue: 0,
    numberOfClicks: 3,
    numberOfShares: 19,
    numberOfBookings: 6,
    nextInviteCategory: null,
    nextInviteDate: null,
    searchKey: ''
  },
  {
    subscriberId: 'VeW7Riu3Z5M',
    fullName: 'Philip Fry',
    locationCountry: 'US',
    locationStateCountry: 'TR',
    phoneNumber: '(555) 555-55-55',
    phoneType: 'Mobile',
    phoneCarrier: 'T-Mobile USA, Inc.',
    addedOn: '2019-05-08T14:48:57.688Z',
    lastUsageOn: '2019-05-08T14:48:57.688Z',
    lastActivityOn: '2019-05-08T14:48:57.688Z',
    lastActivityCampaign: 'Lost6Months',
    businessValue: 0,
    numberOfClicks: 2,
    numberOfShares: 12,
    numberOfBookings: 17,
    nextInviteCategory: null,
    nextInviteDate: null,
    searchKey: ''
  },
  {
    subscriberId: 'QkwfSLo77QZ',
    fullName: 'Hari Seldon',
    locationCountry: 'TR',
    locationStateCountry: 'US',
    phoneNumber: '(555) 555-55-55',
    phoneType: 'Mobile',
    phoneCarrier: 'T-Mobile USA, Inc.',
    addedOn: '2019-05-08T14:48:57.688Z',
    lastUsageOn: '2019-05-08T14:48:57.688Z',
    lastActivityOn: '2019-05-08T14:48:57.688Z',
    lastActivityCampaign: 'Birthday',
    businessValue: 0,
    numberOfClicks: 16,
    numberOfShares: 5,
    numberOfBookings: 4,
    nextInviteCategory: null,
    nextInviteDate: null,
    searchKey: ''
  },
  {
    subscriberId: 'agMLcbLb2dz',
    fullName: 'James Kirk',
    locationCountry: 'CA',
    locationStateCountry: 'TR',
    phoneNumber: '(555) 555-55-55',
    phoneType: 'Mobile',
    phoneCarrier: 'T-Mobile USA, Inc.',
    addedOn: '2019-05-08T14:48:57.688Z',
    lastUsageOn: '2019-05-08T14:48:57.688Z',
    lastActivityOn: '2019-05-08T14:48:57.688Z',
    lastActivityCampaign: 'Lost6Months',
    businessValue: 0,
    numberOfClicks: 2,
    numberOfShares: 18,
    numberOfBookings: 5,
    nextInviteCategory: null,
    nextInviteDate: null,
    searchKey: ''
  },
  {
    subscriberId: 'mmARSIw3JD1',
    fullName: 'Hari Seldon',
    locationCountry: 'CA',
    locationStateCountry: 'US',
    phoneNumber: '(555) 555-55-55',
    phoneType: 'Mobile',
    phoneCarrier: 'T-Mobile USA, Inc.',
    addedOn: '2019-05-08T14:48:57.688Z',
    lastUsageOn: '2019-05-08T14:48:57.688Z',
    lastActivityOn: '2019-05-08T14:48:57.688Z',
    lastActivityCampaign: 'Cancelled',
    businessValue: 0,
    numberOfClicks: 1,
    numberOfShares: 7,
    numberOfBookings: 1,
    nextInviteCategory: null,
    nextInviteDate: null,
    searchKey: ''
  },
  {
    subscriberId: 'f1YtMyWKsye',
    fullName: 'James Kirk',
    locationCountry: 'US',
    locationStateCountry: 'CA',
    phoneNumber: '(555) 555-55-55',
    phoneType: 'Mobile',
    phoneCarrier: 'T-Mobile USA, Inc.',
    addedOn: '2019-05-08T14:48:57.688Z',
    lastUsageOn: '2019-05-08T14:48:57.688Z',
    lastActivityOn: '2019-05-08T14:48:57.688Z',
    lastActivityCampaign: 'Lost6Months',
    businessValue: 0,
    numberOfClicks: 16,
    numberOfShares: 0,
    numberOfBookings: 16,
    nextInviteCategory: null,
    nextInviteDate: null,
    searchKey: ''
  }
]

// function rndInRange(start,end){
//   return Math.floor(Math.random() * (end - start + 1) + start);
// }

// function getDemoAnalyticsDataGenerator() { // in case of edits
//   return (
//     {
//       "dailyActivities": [
//         {
//           "date": "2019-04-01T00:00:00",
//           "dateView": "Apr 01",
//           "invitesSent": rndInRange(200, 300),
//           "clicks": rndInRange(200, 300),
//           "clickRate": rndInRange(30, 100),
//           "bookings": rndInRange(30, 70),
//           "revenue": 0,
//           "conversion": rndInRange(30, 60),
//           campaigns,
//           "clickRateGraph": rndInRange(30, 100),
//         },
//         {
//           "date": "2019-04-02T00:00:00",
//           "dateView": "Apr 02",
//           "invitesSent": rndInRange(200, 300),
//           "clicks": rndInRange(200, 300),
//           "clickRate": rndInRange(30, 100),
//           "bookings": rndInRange(30, 70),
//           "revenue": 0,
//           "conversion": rndInRange(30, 60),
//           campaigns,
//           "clickRateGraph": rndInRange(30, 100),
//         },
//         {
//           "date": "2019-04-03T00:00:00",
//           "dateView": "Apr 03",
//           "invitesSent": rndInRange(200, 300),
//           "clicks": rndInRange(200, 300),
//           "clickRate": rndInRange(30, 100),
//           "bookings": rndInRange(30, 70),
//           "revenue": 0,
//           "conversion": rndInRange(30, 60),
//           campaigns,
//           "clickRateGraph": rndInRange(30, 100),
//         },
//         {
//           "date": "2019-04-04T00:00:00",
//           "dateView": "Apr 04",
//           "invitesSent": rndInRange(200, 300),
//           "clicks": rndInRange(200, 300),
//           "clickRate": rndInRange(30, 100),
//           "bookings": rndInRange(30, 70),
//           "revenue": 0,
//           "conversion": rndInRange(30, 60),
//           campaigns,
//           "clickRateGraph": rndInRange(30, 100),
//         },
//         {
//           "date": "2019-04-05T00:00:00",
//           "dateView": "Apr 05",
//           "invitesSent": 1,
//           "clicks": 1,
//           "clickRate": 100,
//           "bookings": rndInRange(30, 70),
//           "revenue": 0,
//           "conversion": rndInRange(30, 60),
//           campaigns,
//           "clickRateGraph": 100
//         },
//         {
//           "date": "2019-04-06T00:00:00",
//           "dateView": "Apr 06",
//           "invitesSent": rndInRange(200, 300),
//           "clicks": 3,
//           "clickRate": 300,
//           "bookings": rndInRange(30, 70),
//           "revenue": 0,
//           "conversion": rndInRange(30, 60),
//           campaigns,
//           "clickRateGraph": 100
//         },
//         {
//           "date": "2019-04-07T00:00:00",
//           "dateView": "Apr 07",
//           "invitesSent": rndInRange(200, 300),
//           "clicks": rndInRange(200, 300),
//           "clickRate": rndInRange(30, 100),
//           "bookings": rndInRange(30, 70),
//           "revenue": 0,
//           "conversion": rndInRange(30, 60),
//           campaigns,
//           "clickRateGraph": rndInRange(30, 100),
//         },
//         {
//           "date": "2019-04-08T00:00:00",
//           "dateView": "Apr 08",
//           "invitesSent": rndInRange(200, 300),
//           "clicks": rndInRange(200, 300),
//           "clickRate": rndInRange(30, 100),
//           "bookings": rndInRange(30, 70),
//           "revenue": 0,
//           "conversion": rndInRange(30, 60),
//           campaigns,
//           "clickRateGraph": rndInRange(30, 100),
//         },
//         {
//           "date": "2019-04-09T00:00:00",
//           "dateView": "Apr 09",
//           "invitesSent": rndInRange(200, 300),
//           "clicks": rndInRange(200, 300),
//           "clickRate": rndInRange(30, 100),
//           "bookings": rndInRange(30, 70),
//           "revenue": 0,
//           "conversion": rndInRange(30, 60),
//           campaigns,
//           "clickRateGraph": rndInRange(30, 100),
//         },
//         {
//           "date": "2019-04-10T00:00:00",
//           "dateView": "Apr 10",
//           "invitesSent": rndInRange(200, 300),
//           "clicks": rndInRange(200, 300),
//           "clickRate": rndInRange(30, 100),
//           "bookings": rndInRange(30, 70),
//           "revenue": 0,
//           "conversion": rndInRange(30, 60),
//           campaigns,
//           "clickRateGraph": rndInRange(30, 100),
//         },
//         {
//           "date": "2019-04-11T00:00:00",
//           "dateView": "Apr 11",
//           "invitesSent": rndInRange(200, 300),
//           "clicks": rndInRange(200, 300),
//           "clickRate": rndInRange(30, 100),
//           "bookings": rndInRange(30, 70),
//           "revenue": 0,
//           "conversion": rndInRange(30, 60),
//           campaigns,
//           "clickRateGraph": rndInRange(30, 100),
//         },
//         {
//           "date": "2019-04-12T00:00:00",
//           "dateView": "Apr 12",
//           "invitesSent": rndInRange(200, 300),
//           "clicks": rndInRange(200, 300),
//           "clickRate": rndInRange(30, 100),
//           "bookings": rndInRange(30, 70),
//           "revenue": 0,
//           "conversion": rndInRange(30, 60),
//           campaigns,
//           "clickRateGraph": rndInRange(30, 100),
//         },
//         {
//           "date": "2019-04-13T00:00:00",
//           "dateView": "Apr 13",
//           "invitesSent": rndInRange(200, 300),
//           "clicks": rndInRange(200, 300),
//           "clickRate": rndInRange(30, 100),
//           "bookings": rndInRange(30, 70),
//           "revenue": 0,
//           "conversion": rndInRange(30, 60),
//           campaigns,
//           "clickRateGraph": rndInRange(30, 100),
//         },
//         {
//           "date": "2019-04-14T00:00:00",
//           "dateView": "Apr 14",
//           "invitesSent": rndInRange(200, 300),
//           "clicks": rndInRange(200, 300),
//           "clickRate": rndInRange(30, 100),
//           "bookings": rndInRange(30, 70),
//           "revenue": 0,
//           "conversion": rndInRange(30, 60),
//           campaigns,
//           "clickRateGraph": rndInRange(30, 100),
//         },
//         {
//           "date": "2019-04-15T00:00:00",
//           "dateView": "Apr 15",
//           "invitesSent": rndInRange(200, 300),
//           "clicks": rndInRange(200, 300),
//           "clickRate": rndInRange(30, 100),
//           "bookings": rndInRange(30, 70),
//           "revenue": 0,
//           "conversion": rndInRange(30, 60),
//           campaigns,
//           "clickRateGraph": rndInRange(30, 100),
//         },
//         {
//           "date": "2019-04-16T00:00:00",
//           "dateView": "Apr 16",
//           "invitesSent": rndInRange(200, 300),
//           "clicks": rndInRange(200, 300),
//           "clickRate": rndInRange(30, 100),
//           "bookings": rndInRange(30, 70),
//           "revenue": 0,
//           "conversion": rndInRange(30, 60),
//           campaigns,
//           "clickRateGraph": rndInRange(30, 100),
//         },
//         {
//           "date": "2019-04-17T00:00:00",
//           "dateView": "Apr 17",
//           "invitesSent": rndInRange(200, 300),
//           "clicks": rndInRange(200, 300),
//           "clickRate": rndInRange(30, 100),
//           "bookings": rndInRange(30, 70),
//           "revenue": 0,
//           "conversion": rndInRange(30, 60),
//           campaigns,
//           "clickRateGraph": rndInRange(30, 100),
//         },
//         {
//           "date": "2019-04-18T00:00:00",
//           "dateView": "Apr 18",
//           "invitesSent": rndInRange(200, 300),
//           "clicks": rndInRange(200, 300),
//           "clickRate": rndInRange(30, 100),
//           "bookings": rndInRange(30, 70),
//           "revenue": 0,
//           "conversion": rndInRange(30, 60),
//           campaigns,
//           "clickRateGraph": rndInRange(30, 100),
//         },
//         {
//           "date": "2019-04-19T00:00:00",
//           "dateView": "Apr 19",
//           "invitesSent": rndInRange(200, 300),
//           "clicks": 1,
//           "clickRate": 100,
//           "bookings": rndInRange(30, 70),
//           "revenue": 0,
//           "conversion": rndInRange(30, 60),
//           campaigns,
//           "clickRateGraph": 100
//         },
//         {
//           "date": "2019-04-20T00:00:00",
//           "dateView": "Apr 20",
//           "invitesSent": rndInRange(200, 300),
//           "clicks": rndInRange(200, 300),
//           "clickRate": rndInRange(30, 100),
//           "bookings": rndInRange(30, 70),
//           "revenue": 0,
//           "conversion": rndInRange(30, 60),
//           campaigns,
//           "clickRateGraph": rndInRange(30, 100),
//         },
//         {
//           "date": "2019-04-21T00:00:00",
//           "dateView": "Apr 21",
//           "invitesSent": rndInRange(200, 300),
//           "clicks": rndInRange(200, 300),
//           "clickRate": rndInRange(30, 100),
//           "bookings": rndInRange(30, 70),
//           "revenue": 0,
//           "conversion": rndInRange(30, 60),
//           campaigns,
//           "clickRateGraph": rndInRange(30, 100),
//         },
//         {
//           "date": "2019-04-22T00:00:00",
//           "dateView": "Apr 22",
//           "invitesSent": rndInRange(200, 300),
//           "clicks": rndInRange(200, 300),
//           "clickRate": rndInRange(30, 100),
//           "bookings": rndInRange(30, 70),
//           "revenue": 0,
//           "conversion": rndInRange(30, 60),
//           campaigns,
//           "clickRateGraph": rndInRange(30, 100),
//         },
//         {
//           "date": "2019-04-23T00:00:00",
//           "dateView": "Apr 23",
//           "invitesSent": rndInRange(200, 300),
//           "clicks": rndInRange(200, 300),
//           "clickRate": rndInRange(30, 100),
//           "bookings": rndInRange(30, 70),
//           "revenue": 0,
//           "conversion": rndInRange(30, 60),
//           campaigns,
//           "clickRateGraph": rndInRange(30, 100),
//         },
//         {
//           "date": "2019-04-24T00:00:00",
//           "dateView": "Apr 24",
//           "invitesSent": rndInRange(200, 300),
//           "clicks": rndInRange(200, 300),
//           "clickRate": rndInRange(30, 100),
//           "bookings": rndInRange(30, 70),
//           "revenue": 0,
//           "conversion": rndInRange(30, 60),
//           campaigns,
//           "clickRateGraph": rndInRange(30, 100),
//         },
//         {
//           "date": "2019-04-25T00:00:00",
//           "dateView": "Apr 25",
//           "invitesSent": 3,
//           "clicks": rndInRange(200, 300),
//           "clickRate": rndInRange(30, 100),
//           "bookings": rndInRange(30, 70),
//           "revenue": 0,
//           "conversion": rndInRange(30, 60),
//           campaigns,
//           "clickRateGraph": rndInRange(30, 100),
//         },
//         {
//           "date": "2019-04-26T00:00:00",
//           "dateView": "Apr 26",
//           "invitesSent": 4,
//           "clicks": rndInRange(200, 300),
//           "clickRate": rndInRange(30, 100),
//           "bookings": rndInRange(30, 70),
//           "revenue": 0,
//           "conversion": rndInRange(30, 60),
//           campaigns,
//           "clickRateGraph": rndInRange(30, 100),
//         },
//         {
//           "date": "2019-04-27T00:00:00",
//           "dateView": "Apr 27",
//           "invitesSent": rndInRange(200, 300),
//           "clicks": rndInRange(200, 300),
//           "clickRate": rndInRange(30, 100),
//           "bookings": rndInRange(30, 70),
//           "revenue": 0,
//           "conversion": rndInRange(30, 60),
//           campaigns,
//           "clickRateGraph": rndInRange(30, 100),
//         },
//         {
//           "date": "2019-04-28T00:00:00",
//           "dateView": "Apr 28",
//           "invitesSent": rndInRange(200, 300),
//           "clicks": rndInRange(200, 300),
//           "clickRate": rndInRange(30, 100),
//           "bookings": rndInRange(30, 70),
//           "revenue": 0,
//           "conversion": rndInRange(30, 60),
//           campaigns,
//           "clickRateGraph": rndInRange(30, 100),
//         },
//         {
//           "date": "2019-04-29T00:00:00",
//           "dateView": "Apr 29",
//           "invitesSent": rndInRange(200, 300),
//           "clicks": rndInRange(200, 300),
//           "clickRate": rndInRange(30, 100),
//           "bookings": rndInRange(30, 70),
//           "revenue": 0,
//           "conversion": rndInRange(30, 60),
//           campaigns,
//           "clickRateGraph": rndInRange(30, 100),
//         },
//         {
//           "date": "2019-04-30T00:00:00",
//           "dateView": "Apr 30",
//           "invitesSent": 11,
//           "clicks": rndInRange(200, 300),
//           "clickRate": rndInRange(30, 100),
//           "bookings": rndInRange(30, 70),
//           "revenue": 0,
//           "conversion": rndInRange(30, 60),
//           campaigns,
//           "clickRateGraph": rndInRange(30, 100),
//         }
//       ],
//       "totalInvitesSent": 1020,
//       "totalClicks": 750,
//       "clickRate": 90.32,
//       "totalBookings": 5723,
//       "averageConversion": 56.48,
//       "totalConvertedRevenue": 324551,
//       "campaignsSummary": [
//         {
//           "uiId": "0101011",
//           "campaign": "AfterLastVisit",
//           "invitesSent": 13,
//           "clicks": 5,
//           "clickRate": 90.96
//         },
//         {
//           "uiId": "0101016",
//           "campaign": "CardAbandonmentOptedIn",
//           "invitesSent": 5,
//           "clicks": rndInRange(200, 300),
//           "clickRate": 78.46
//         },
//         {
//           "uiId": "0101015",
//           "campaign": "CheckedOutReview",
//           "invitesSent": 1,
//           "clicks": rndInRange(200, 300),
//           "clickRate": 85.24
//         }
//       ]
//     }
//   )
// }

// const getRandomName = () => ['John Doe', 'Michelle Burnham', 'Hari Seldon', 'Jonathan Riker', 'Ye Wenjie', 'Philip Fry', 'James Kirk' ][Math.floor(Math.random() * 7)]

// function getSingleGuestData() {
//   return {
//     key: shortid.generate(),
//     subscriberId: shortid.generate(),
//     locationCountry: ['TR', 'US', 'CA'][Math.floor(Math.random() * 3)],
//     fullName: ['John Doe', 'Michelle Burnham', 'Hari Seldon', 'Jonathan Riker', 'Ye Wenjie' ][Math.floor(Math.random() * 3)],
//     phoneNumber: '(555) 555-55-55',
//     phoneCarrier: "T-Mobile USA",
//     lastUsageOn: [moment().subtract(2, 'days').toString(), moment().subtract(3, 'days').toString(), moment().subtract(Math.floor(Math.random() * 5), 'hours').toString()][Math.floor(Math.random() * 3)],
//     numberOfClicks: Math.floor(Math.random() * 20),
//     numberOfShares: Math.floor(Math.random() * 20),
//     numberOfBookings: 0,
//     lastActivityCampaign: ['Cancelled', 'Birthday', 'Lost6Months'][Math.floor(Math.random() * 3)],
//     lastActivityOn: [moment().subtract(2, 'days').toString(), moment().subtract(3, 'days').toString(), moment().subtract(Math.floor(Math.random() * 5), 'hours').toString()][Math.floor(Math.random() * 3)],
//     totalValue: [1200, 700, 24004][Math.floor(Math.random() * 3)],
//     totalNumberOfBookings: 5,
//     businessValue: 10,
//   }
// }

// function getDemoActiveGuestData() {
//   return (
//     [
//       {
//         subscriberId: shortid.generate(),
//         fullName: getRandomName(),
//         locationCountry: ['TR', 'US', 'CA'][Math.floor(Math.random() * 3)],
//         locationStateCountry: ['TR', 'US', 'CA'][Math.floor(Math.random() * 3)],
//         phoneNumber: '(555) 555-55-55',
//         phoneType: 'Mobile',
//         phoneCarrier: 'T-Mobile USA, Inc.',
//         addedOn: "2019-05-08T14:48:57.688Z",
//         lastUsageOn: "2019-05-08T14:48:57.688Z",
//         lastActivityOn: "2019-05-08T14:48:57.688Z",
//         lastActivityCampaign: ['Cancelled', 'Birthday', 'Lost6Months'][Math.floor(Math.random() * 3)],
//         businessValue: 0,
//         numberOfClicks: Math.floor(Math.random() * 20),
//         numberOfShares: Math.floor(Math.random() * 20),
//         numberOfBookings: Math.floor(Math.random() * 20),
//         nextInviteCategory: null,
//         nextInviteDate: null,
//         searchKey: ''
//       },
//       {
//         subscriberId: shortid.generate(),
//         fullName: getRandomName(),
//         locationCountry: ['TR', 'US', 'CA'][Math.floor(Math.random() * 3)],
//         locationStateCountry: ['TR', 'US', 'CA'][Math.floor(Math.random() * 3)],
//         phoneNumber: '(555) 555-55-55',
//         phoneType: 'Mobile',
//         phoneCarrier: 'T-Mobile USA, Inc.',
//         addedOn: "2019-05-08T14:48:57.688Z",
//         lastUsageOn: "2019-05-08T14:48:57.688Z",
//         lastActivityOn: "2019-05-08T14:48:57.688Z",
//         lastActivityCampaign: ['Cancelled', 'Birthday', 'Lost6Months'][Math.floor(Math.random() * 3)],
//         businessValue: 0,
//         numberOfClicks: Math.floor(Math.random() * 20),
//         numberOfShares: Math.floor(Math.random() * 20),
//         numberOfBookings: Math.floor(Math.random() * 20),
//         nextInviteCategory: null,
//         nextInviteDate: null,
//         searchKey: ''
//       },
//       {
//         subscriberId: shortid.generate(),
//         fullName: getRandomName(),
//         locationCountry: ['TR', 'US', 'CA'][Math.floor(Math.random() * 3)],
//         locationStateCountry: ['TR', 'US', 'CA'][Math.floor(Math.random() * 3)],
//         phoneNumber: '(555) 555-55-55',
//         phoneType: 'Mobile',
//         phoneCarrier: 'T-Mobile USA, Inc.',
//         addedOn: "2019-05-08T14:48:57.688Z",
//         lastUsageOn: "2019-05-08T14:48:57.688Z",
//         lastActivityOn: "2019-05-08T14:48:57.688Z",
//         lastActivityCampaign: ['Cancelled', 'Birthday', 'Lost6Months'][Math.floor(Math.random() * 3)],
//         businessValue: 0,
//         numberOfClicks: Math.floor(Math.random() * 20),
//         numberOfShares: Math.floor(Math.random() * 20),
//         numberOfBookings: Math.floor(Math.random() * 20),
//         nextInviteCategory: null,
//         nextInviteDate: null,
//         searchKey: ''
//       },
//       {
//         subscriberId: shortid.generate(),
//         fullName: getRandomName(),
//         locationCountry: ['TR', 'US', 'CA'][Math.floor(Math.random() * 3)],
//         locationStateCountry: ['TR', 'US', 'CA'][Math.floor(Math.random() * 3)],
//         phoneNumber: '(555) 555-55-55',
//         phoneType: 'Mobile',
//         phoneCarrier: 'T-Mobile USA, Inc.',
//         addedOn: "2019-05-08T14:48:57.688Z",
//         lastUsageOn: "2019-05-08T14:48:57.688Z",
//         lastActivityOn: "2019-05-08T14:48:57.688Z",
//         lastActivityCampaign: ['Cancelled', 'Birthday', 'Lost6Months'][Math.floor(Math.random() * 3)],
//         businessValue: 0,
//         numberOfClicks: Math.floor(Math.random() * 20),
//         numberOfShares: Math.floor(Math.random() * 20),
//         numberOfBookings: Math.floor(Math.random() * 20),
//         nextInviteCategory: null,
//         nextInviteDate: null,
//         searchKey: ''
//       },
//       {
//         subscriberId: shortid.generate(),
//         fullName: getRandomName(),
//         locationCountry: ['TR', 'US', 'CA'][Math.floor(Math.random() * 3)],
//         locationStateCountry: ['TR', 'US', 'CA'][Math.floor(Math.random() * 3)],
//         phoneNumber: '(555) 555-55-55',
//         phoneType: 'Mobile',
//         phoneCarrier: 'T-Mobile USA, Inc.',
//         addedOn: "2019-05-08T14:48:57.688Z",
//         lastUsageOn: "2019-05-08T14:48:57.688Z",
//         lastActivityOn: "2019-05-08T14:48:57.688Z",
//         lastActivityCampaign: ['Cancelled', 'Birthday', 'Lost6Months'][Math.floor(Math.random() * 3)],
//         businessValue: 0,
//         numberOfClicks: Math.floor(Math.random() * 20),
//         numberOfShares: Math.floor(Math.random() * 20),
//         numberOfBookings: Math.floor(Math.random() * 20),
//         nextInviteCategory: null,
//         nextInviteDate: null,
//         searchKey: ''
//       },
//       {
//         subscriberId: shortid.generate(),
//         fullName: getRandomName(),
//         locationCountry: ['TR', 'US', 'CA'][Math.floor(Math.random() * 3)],
//         locationStateCountry: ['TR', 'US', 'CA'][Math.floor(Math.random() * 3)],
//         phoneNumber: '(555) 555-55-55',
//         phoneType: 'Mobile',
//         phoneCarrier: 'T-Mobile USA, Inc.',
//         addedOn: "2019-05-08T14:48:57.688Z",
//         lastUsageOn: "2019-05-08T14:48:57.688Z",
//         lastActivityOn: "2019-05-08T14:48:57.688Z",
//         lastActivityCampaign: ['Cancelled', 'Birthday', 'Lost6Months'][Math.floor(Math.random() * 3)],
//         businessValue: 0,
//         numberOfClicks: Math.floor(Math.random() * 20),
//         numberOfShares: Math.floor(Math.random() * 20),
//         numberOfBookings: Math.floor(Math.random() * 20),
//         nextInviteCategory: null,
//         nextInviteDate: null,
//         searchKey: ''
//       },
//       {
//         subscriberId: shortid.generate(),
//         fullName: getRandomName(),
//         locationCountry: ['TR', 'US', 'CA'][Math.floor(Math.random() * 3)],
//         locationStateCountry: ['TR', 'US', 'CA'][Math.floor(Math.random() * 3)],
//         phoneNumber: '(555) 555-55-55',
//         phoneType: 'Mobile',
//         phoneCarrier: 'T-Mobile USA, Inc.',
//         addedOn: "2019-05-08T14:48:57.688Z",
//         lastUsageOn: "2019-05-08T14:48:57.688Z",
//         lastActivityOn: "2019-05-08T14:48:57.688Z",
//         lastActivityCampaign: ['Cancelled', 'Birthday', 'Lost6Months'][Math.floor(Math.random() * 3)],
//         businessValue: 0,
//         numberOfClicks: Math.floor(Math.random() * 20),
//         numberOfShares: Math.floor(Math.random() * 20),
//         numberOfBookings: Math.floor(Math.random() * 20),
//         nextInviteCategory: null,
//         nextInviteDate: null,
//         searchKey: ''
//       },
//       {
//         subscriberId: shortid.generate(),
//         fullName: getRandomName(),
//         locationCountry: ['TR', 'US', 'CA'][Math.floor(Math.random() * 3)],
//         locationStateCountry: ['TR', 'US', 'CA'][Math.floor(Math.random() * 3)],
//         phoneNumber: '(555) 555-55-55',
//         phoneType: 'Mobile',
//         phoneCarrier: 'T-Mobile USA, Inc.',
//         addedOn: "2019-05-08T14:48:57.688Z",
//         lastUsageOn: "2019-05-08T14:48:57.688Z",
//         lastActivityOn: "2019-05-08T14:48:57.688Z",
//         lastActivityCampaign: ['Cancelled', 'Birthday', 'Lost6Months'][Math.floor(Math.random() * 3)],
//         businessValue: 0,
//         numberOfClicks: Math.floor(Math.random() * 20),
//         numberOfShares: Math.floor(Math.random() * 20),
//         numberOfBookings: Math.floor(Math.random() * 20),
//         nextInviteCategory: null,
//         nextInviteDate: null,
//         searchKey: ''
//       }
//     ]
//   )
// }
